<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelContract()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Contract</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content #content>
    <datepicker [document]="documentTemp"></datepicker>
    <customer [document]="documentTemp" (customerChange)="listenCustomer($event)"
              (documentChange)="listenDocument($event)"></customer>
    <site [document]="documentTemp"></site>
    <items-order-fulfilment
            *ngIf="(documentTemp.documentType === docTypes.CONTRACT || documentTemp.documentType === docTypes.STOCKING) && documentTemp.parentDocument"
            [document]="documentTemp"></items-order-fulfilment>
    <items *ngIf="documentTemp.customer.name" [document]="documentTemp"></items>
    <patient-info [document]="documentTemp"></patient-info>
    <comments [document]="documentTemp"></comments>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (click)="saveContract()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>

</ion-content>


